import ThemeSchema from './schema';
import colors from './colors';
import { fontSize } from './constants';

const cpDarkTheme: ThemeSchema = {
  accordion: {
    text: colors.white,
    subText: colors.gray_20,
    caret: colors.gray_40,
    border: colors.gray_50,
    icon: colors.gray_30,
  },
  font: {
    fontFamily: '"Roboto", sans-serif',
    fontLinks: [
      {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
        crossorigin: false,
      },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
        crossorigin: true,
      },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap',
        crossorigin: false,
      },
    ],
  },
  headingFont: {
    fontFamily: '"Roboto", sans-serif',
    fontSize,
  },
  form: {
    label: colors.white,
    fieldset: {
      bg: colors.gray_90,
      border: colors.white,
      text: colors.gray_05,
    },
  },
  page: {
    header: {
      bg: colors.eerie_black,
      border: colors.gray_50,
      text: colors.white,
    },
    headerLogo: {
      bg: colors.gray_90,
    },
    body: {
      bg: colors.gray_90,
      headerText: colors.white,
      text: colors.white,
    },
    footer: {
      bg: colors.eerie_black,
      border: colors.gray_50,
      text: colors.gray_30,
    },
  },
  card: {
    header: {
      bg: colors.eerie_black,
      text: colors.white,
      border: colors.gray_50,
    },
    body: {
      bg: colors.eerie_black,
      text: colors.white,
      headerText: colors.white,
    },
  },
  timeline: {
    icon: colors.white,
    line: colors.gray_40,
    description: colors.gray_10,
    time: colors.white,
  },
  displayNumber: {
    title: colors.gray_30,
    value: colors.gray_20,
    unit: colors.gray_20,
  },
  select: {
    bottomBorder: colors.gray_20,
    selectedOptionText: colors.orange_50,
    unselectedOptionText: colors.white,
    focusedOptionBackground: colors.gray_50,
    text: colors.white,
    icons: colors.gray_20,
    background: colors.gray_70,
  },
  button: {
    primary: {
      normal: {
        bg: colors.orange_50,
        text: colors.gray_90,
      },
      disabled: {
        bg: colors.gray_20,
        text: colors.gray_50,
      },
      hover: {
        bg: colors.orange_55,
      },
    },
    secondary: {
      normal: {
        bg: colors.transparent,
        border: colors.orange_50,
        text: colors.white,
      },
      disabled: {
        border: colors.gray_30,
        text: colors.gray_50,
      },
      hover: {
        bg: colors.orange_50,
      },
    },
    circle: {
      normal: {
        bg: colors.white,
        text: colors.gray_70,
      },
      hover: {
        bg: colors.gray_20,
      },
      disabled: {
        bg: colors.gray_30,
      },
    },
    link: {
      normal: {
        text: colors.white,
      },
      hover: {
        bg: colors.gray_70,
      },
    },
    danger: {
      normal: {
        bg: colors.transparent,
        text: colors.orange_50,
      },
    },
  },
  link: {
    text: colors.gray_30,
    hover: colors.gray_40,
    disabled: colors.gray_50,
    active: colors.gray_70,
    focus: colors.white,
  },
  icon: colors.gray_30,
  focus: colors.orange_30,
  label: colors.gray_20,
  error: colors.orange_50,
  input: {
    normal: {
      text: colors.white,
      bottomBorder: colors.gray_20,
      bg: colors.gray_70,
    },
    focus: {
      text: colors.white,
      bg: colors.gray_50,
    },
    disabled: {
      text: colors.gray_20,
    },
    hover: {
      text: colors.gray_20,
    },
  },
  checkbox: {
    label: colors.gray_20,
    color: colors.orange_55,
  },
  spinner: {
    color: colors.orange_55,
  },
  tabs: {
    text: colors.gray_30,
    selectedText: colors.white,
    bottomBorder: colors.gray_50,
  },
  shadow: {
    default: `${colors.black}87`,
    hover: `${colors.black}b5`,
  },
  modal: {
    separator: colors.gray_50,
  },
  info: {
    headerText: colors.white,
    text: colors.gray_30,
    date: colors.gray_30,
    border: colors.gray_10,
    icon: colors.gray_30,
  },
  imagePlaceholder: {
    bg: colors.blue_gray_50,
    text: colors.gray_90,
  },
  datePicker: {
    bg: colors.gray_90,
    border: colors.gray_40,
  },
};

export default cpDarkTheme;
